export default __webpack_public_path__ + "static/media/IBimageRearpendulum1.1c0356fd.png";